import React from "react";
import { Grid, Paper, Typography, Container } from "@mui/material";

import SiteCard from "../SiteCard";

const DisplaySites = ({
  isTemplatesSite,
  isAdminTemplates,
  data,
  onManage,
  onEdit,
  onDelete,
}) => {
  return (
    <Container maxWidth="2xl" sx={{ px: '0px !important' }}>
      <Grid container spacing={2}>
        {data.map((site) => (
          <Grid item xs={12} key={site.id}>
            <SiteCard
              isAdminTemplates={isAdminTemplates}
              isTemplatesSite={isTemplatesSite}
              site={site}
              onEdit={onEdit}
              onDelete={onDelete}
              onManage={onManage}
            />
          </Grid>
        ))}
        {data.length === 0 && (
          <Grid item xs={12}>
            <Paper sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="body1" color="text.secondary">
                No sites found. Create a site to get started.
              </Typography>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default DisplaySites;